const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/roadmap/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { saveLastVisitedVisualization } from '@/features/visualizations/utils/lastVisitedVisualizationView';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio/view/$viewId/roadmap/')({
  loader: ({
    params
  }) => saveLastVisitedVisualization(Number(params.viewId), 'timeline'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});